<!--
    描述：电子保函 -> 开函申请 -> 详情
    时间：2023-02-06
    Created by zcc
-->
<template>
  <div class="member-detail-page">
    <!-- 开函申请信息 -->
    <div class="item">
      <el-divider content-position="left">开函申请信息：</el-divider>
      <div class="main-content">
        <el-row>
          <el-col :span="6"> 业务流水号：{{ applyInfoForm.id }} </el-col>
          <el-col :span="6">
            申请开函单位：{{ applyInfoForm.enterpriseName }}
          </el-col>
          <el-col :span="6">
            统一社会信用代码：{{ applyInfoForm.creditCode }}
          </el-col>
          <el-col :span="6">
            企业类型：
            <span v-if="applyInfoForm.companyType == '1'">国有企业</span>
            <span v-else-if="applyInfoForm.companyType == '2'">股份有限</span>
            <span v-else-if="applyInfoForm.companyType == '3'">有限责任</span>
            <span v-else-if="applyInfoForm.companyType == '4'">民营</span>
            <span v-else-if="applyInfoForm.companyType == '5'">
              中外合资/合作
            </span>
            <span v-else-if="applyInfoForm.companyType == '6'">外商独资</span>
            <span v-else-if="applyInfoForm.companyType == '7'">集体单位</span>
            <span v-else-if="applyInfoForm.companyType == '8'">事业单位</span>
            <span v-else-if="applyInfoForm.companyType == '9'">个人</span>
            <span v-else-if="applyInfoForm.companyType == '10'">
              全民所有制
            </span>
            <span v-else-if="applyInfoForm.companyType == '0'">其他</span>
            <span v-else></span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6"> 法定代表人：{{ applyInfoForm.legalName }} </el-col>
          <el-col :span="6">
            法定代表人证件类型：
            <span v-if="applyInfoForm.certType == '1'">身份证</span>
            <span v-else-if="applyInfoForm.certType == '2'">护照</span>
            <span v-else-if="applyInfoForm.certType == '3'">军官证</span>
            <span v-else-if="applyInfoForm.certType == '4'">组织机构代码</span>
            <span v-else-if="applyInfoForm.certType == '5'">社会信用代码</span>
            <span v-else>其他</span>
          </el-col>
          <el-col :span="6">
            法定代表人证件号：{{ applyInfoForm.legalCertNo }}
          </el-col>
          <el-col :span="6">
            法定代表人电话：{{ applyInfoForm.legalPhone }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            经办人姓名：{{ applyInfoForm.operatorName }}
          </el-col>
          <el-col :span="6">
            经办人证件类型：
            <span v-if="applyInfoForm.operatorCertType == '1'">身份证</span>
            <span v-else-if="applyInfoForm.operatorCertType == '2'">护照</span>
            <span v-else-if="applyInfoForm.operatorCertType == '3'">
              军官证
            </span>
            <span v-else-if="applyInfoForm.operatorCertType == '4'">
              组织机构代码
            </span>
            <span v-else-if="applyInfoForm.operatorCertType == '5'">
              社会信用代码
            </span>
            <span v-else>其他</span>
          </el-col>
          <el-col :span="6">
            经办人证件号：{{ applyInfoForm.operatorCertNo }}
          </el-col>
          <el-col :span="6">
            经办人联系电话：{{ applyInfoForm.operatorPhone }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            项目标段唯一标识：{{ applyInfoForm.projectBidUniqueNo }}
          </el-col>
          <el-col :span="6"> 标段名称：{{ applyInfoForm.bidName }} </el-col>
          <el-col :span="6"> 标段编号：{{ applyInfoForm.bidNo }} </el-col>
          <el-col :span="6">
            开标日期：{{ applyInfoForm.bidOpeningDate }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            保函类型：
            <span v-if="applyInfoForm.businessType == '01'">
              投标保函
            </span>
            <span v-else-if="applyInfoForm.businessType == '02'">
              政采保函
            </span>
            <span v-else-if="applyInfoForm.businessType == '03'">
              履约保函
            </span>
          </el-col>
          <el-col :span="6">
            开函机构：
            <span v-if="applyInfoForm.financialId == '1'">瀚华担保</span>
          </el-col>
          <el-col :span="6"> 保函申请编号：{{ applyInfoForm.lgNo }} </el-col>
          <el-col :span="6">
            保函申请金额：
            {{ applyInfoForm.guaranteeAmount }}
            <span v-if="applyInfoForm.guaranteeAmount">元</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            保函支付金额：
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="showPhoto">
            附加：
            <span>
              <div v-for="(item, index) in applyInfoForm.fileList" :key="index">
                <el-link
                  type="primary"
                  @click="
                    showPhoto(item.fileName, item.fileUrl, item.fileSuffix)
                  "
                >
                  {{ item.fileName }}
                </el-link>
                <i
                  v-if="applyInfoForm.fileList.length"
                  class="el-icon-download download-img"
                  @click="downloadFile(item.fileUrl)"
                ></i>
              </div>
            </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6"> 申请人：{{ applyInfoForm.applyUserName }} </el-col>
          <el-col :span="6"> 申请时间：{{ applyInfoForm.createDate }} </el-col>
          <el-col :span="6">
            业务来源：{{ applyInfoForm.sysSourceName }}
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 开函信息 -->
    <div class="item">
      <el-divider content-position="left">开函信息：</el-divider>
      <div class="main-content">
        <el-row>
          <el-col :span="6">
            准入状态：
            <span class="showStatus">
              <span v-if="applyInfoForm.admittanceState == '0'" class="fail">
                准入失败
              </span>
              <span v-else class="success"> 已准入 </span>
            </span>
          </el-col>
          <el-col :span="6">
            失败原因：{{ applyInfoForm.failureReason }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="link-span">
            <span class="link-title">支付跳转链接：</span>
            <a :href="applyInfoForm.payUrl" target="_blank" class="link-long">
              {{ applyInfoForm.payUrl }}
            </a>
          </el-col>
          <el-col :span="6"> 支付金额：</el-col>
          <el-col :span="6">
            支付状态：
            <span v-if="applyInfoForm.payStatus == '03'">支付失败</span>
            <span v-else-if="applyInfoForm.payStatus == '00'">支付成功</span>
            <span v-else-if="applyInfoForm.payStatus == '02'">支付中</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            开函状态：
            <span class="showStatus">
              <span v-if="applyInfoForm.openStatus == '1'" class="between">
                审核中
              </span>
              <span v-else-if="applyInfoForm.openStatus == '2'" class="success">
                已开函
              </span>
              <span v-else-if="applyInfoForm.openStatus == '3'" class="success">
                已解保
              </span>
              <span v-else-if="applyInfoForm.openStatus == '4'" class="fail">
                已拒绝
              </span>
              <span v-else-if="applyInfoForm.openStatus == '5'" class="fail">
                已撤销
              </span>
            </span>
          </el-col>
          <el-col :span="6" v-if="baseInfoForm">
            失败原因：{{ baseInfoForm.auditOpinion }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            瀚华保函编号：{{ baseInfoForm.guaranteeNumber }}
          </el-col>
          <el-col :span="6">
            保函代码：{{ baseInfoForm.guaranteeCode }}
          </el-col>
          <el-col :span="6">
            担保企业名称：瀚华担保
          </el-col>
          <el-col :span="6"> 出函时间：{{ baseInfoForm.createTime }} </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            担保金额：{{ baseInfoForm.guaranteeAmount }}
          </el-col>
          <el-col :span="6">
            电子保函有限截止时间：{{ baseInfoForm.letterExpireEndTime }}
          </el-col>
          <el-col :span="6"> 保函办理人：{{ baseInfoForm.transactor }} </el-col>
          <el-col :span="6">
            办理人联系电话：{{ baseInfoForm.transactorNumber }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            保函类型：
            <span v-if="baseInfoForm.ensureType == 'bank'">银行保函</span>
            <span v-else-if="baseInfoForm.ensureType == 'company'">
              担保保函
            </span>
            <span v-else-if="baseInfoForm.ensureType == 'insurance'">
              保险保函
            </span>
          </el-col>
          <el-col :span="6"> 金融机构名称：{{ baseInfoForm.orgName }} </el-col>
          <el-col :span="6"> 投标申请编号：{{ baseInfoForm.lgNo }} </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="link-span">
            <span class="link-title">保函文件下载URL：</span>
            <a :href="baseInfoForm.guaranteeFileUrl" target="_blank">
              <span class="link-long">
                {{ baseInfoForm.guaranteeFileUrl }}
              </span>
            </a>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 撤销信息 -->
    <div class="item" v-if="revocation">
      <el-divider content-position="left">撤销信息：</el-divider>
      <div class="main-content">
        <el-row>
          <el-col :span="6">
            撤销状态：
            <span class="showStatus">
              <span v-if="revocationForm.status == '0'" class="fail">失败</span>
              <span v-else-if="revocationForm.status == '1'" class="success">
                成功
              </span>
            </span>
          </el-col>
          <el-col :span="6"> 失败原因：{{ revocationForm.reason }} </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            申请人：{{ revocationForm.applyUserName }}
          </el-col>
          <el-col :span="6"> 申请日期：{{ revocationForm.createDate }} </el-col>
        </el-row>
      </div>
    </div>

    <el-dialog
      :title="photoDialogTitle"
      :visible.sync="photoDialogVisible"
      width="50%"
    >
      <span>
        <div v-if="suffix == 'jpg' || 'gif' || 'jpg' || 'jpeg' || 'png'">
          <el-image
            style="width: 80%;margin: 0 10%;"
            :src="url"
            fit="width"
            :preview-src-list="srcList"
          ></el-image>
        </div>
        <div v-else>
          <iframe :src="pdfUrl" style="height: 500px; width: 100%"></iframe>
        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="photoDialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as API from "api/modules/bh/bh-letter-application";
export default {
  name: "detail",
  data() {
    return {
      // 开函申请信息
      applyInfoForm: {
        id: "", //业务流水号
        enterpriseName: "", //申请开函单位
        creditCode: "", //统一社会信用代码
        companyType: "", //企业类型
        legalName: "", //法定代表人
        certType: "", //法定代表人证件类型
        legalCertNo: "", //法定代表人证件号
        legalPhone: "", //法定代表人电话
        operatorName: "", //经办人姓名
        operatorCertType: "", //经办人证件类型
        operatorCertNo: "", //经办人证件号
        operatorPhone: "", //经办人联系电话
        projectBidUniqueNo: "", //项目标段唯一标识
        bidName: "", //标段名称
        bidNo: "", //标段编号
        bidOpeningDate: "", //开标日期
        businessType: "", //保函类型
        financialId: "", //开函机构
        lgNo: "", //保函申请编号
        guaranteeAmount: "", //保函申请金额
        // payAmount: "", //保函支付金额
        applyUserName: "", //申请人
        createDate: "", //申请时间
        sysSourceName: "", //业务来源
        admittanceState: "", //准入状态
        failureReason: "", //失败原因
        payUrl: "", //支付跳转链接
        // payMoney: "", //支付金额
        payStatus: "", //支付状态
        openStatus: "", //开函状态
        fileList: [
          {
            fileName: "", //附件名称
            fileUrl: "", //附件url
            fileSuffix: "", //文件后缀
          },
        ], //附加
      },
      url: "", //dialog显示文件地址
      photoDialogTitle: "", //dialog显示文件名称
      suffix: "", //文件的后缀
      srcList: [], //图片预览
      pdfUrl: "", //pdf预览
      // 基本信息
      baseInfoForm: {
        auditOpinion: "", //失败原因
        guaranteeNumber: "", //瀚华保函编号
        guaranteeCode: "", //保函代码
        createTime: "", //出函时间
        guaranteeAmount: "", //担保金额
        letterExpireEndTime: "", //电子保函有限截止时间
        transactor: "", //保函办理人
        transactorNumber: "", //办理人联系电话
        ensureType: "", //保函类型
        orgName: "", //金融机构名称
        lgNo: "", //投标申请编号
        guaranteeFileUrl: "", //保函文件下载URL
      },
      // 撤销信息
      revocationForm: {
        status: "", //撤销状态
        reason: "", //失败原因
        applyUserName: "", //申请人
        createDate: "", //申请日期
      },
      revocation: false, //撤销信息是否显示
      photoDialogVisible: false, //图片对话框
    };
  },
  mounted() {},
  computed: {
    bhId() {
      return this.$route.query.id;
    },
  },
  created() {
    this.getInit();
  },
  methods: {
    getInit() {
      this.getSelectApplyInfo();
      this.getSelectBaseInfo();
      this.getSelectBhRevocation();
    },
    // 申请信息
    getSelectApplyInfo() {
      let param = {
        id: this.bhId,
      };
      API.getSelectApplyInfo(param).then((res) => {
        if (res.operationCode == 1) {
          Object.keys(this.applyInfoForm).forEach(
            (key) => (this.applyInfoForm[key] = res.data[key])
          );
        }
      });
    },
    // 基本信息
    getSelectBaseInfo() {
      let param = {
        lgNo: this.bhId,
      };
      API.getSelectBaseInfo(param).then((res) => {
        if (res.operationCode == 1 && res.data) {
          Object.keys(this.baseInfoForm).forEach(
            (key) => (this.baseInfoForm[key] = res.data[key])
          );
        }
      });
    },
    // 撤保信息
    getSelectBhRevocation() {
      let param = {
        lgNo: this.bhId,
      };
      API.getSelectBhRevocation(param).then((res) => {
        if (res.operationCode == 1) {
          if (res.data != null) {
            this.revocation = true;
            Object.keys(this.revocationForm).forEach(
              (key) => (this.revocationForm[key] = res.data[key])
            );
          } else {
            this.revocation = false;
          }
        }
      });
    },
    //点击展示图片
    showPhoto(name, fileUrl, suffix) {
      this.srcList = [];
      this.photoDialogVisible = true;
      if (name.length > 30) {
        this.photoDialogTitle = name.substring(0, 30);
      } else {
        this.photoDialogTitle = name;
      }
      this.url = fileUrl;
      if (suffix == "pdf") {
        this.pdfUrl =
          "https://pdf.52ngs.com/onlinePreview?url=" + fileUrl;
      } else {
        this.srcList.push(this.url);
      }
      this.suffix = suffix;
    },
    //下载
    downloadFile(url) {
      window.open(url);
    },
  },
};
</script>

<style lang="less" scoped>
.member-detail-page {
  .item {
    .main-content {
      font-family: "Arial Normal", "Arial";
      font-weight: 400;
      font-style: normal;
      font-size: 13px;
      color: #333333;
      line-height: normal;
      padding: 0 40px;

      .el-row {
        padding: 10px 0px;
      }

      .showPhoto {
        display: flex;

        span {
          display: flex;
          justify-content: flex-start;
          flex-direction: column;

          div {
            display: flex;
            justify-content: center;
            align-items: center;

            .download-img {
              font-size: 18px;
              cursor: pointer;
              margin-left: 10px;
              color: #409eff;

              &:hover {
                color: #7fb8ff;
              }
            }
          }
        }
      }

      .showStatus {
        .success {
          color: #008000;
        }

        .between {
          color: #ff9900;
        }

        .fail {
          color: #ff0000;
        }
      }

      .link-span {
        display: flex;
        padding-right: 20px;

        .link-title {
          white-space: nowrap;
        }

        .link-long {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #409eff;
          cursor: pointer;
          border-bottom: 1px solid #fff;

          &:hover {
            border-bottom: 1px solid #409eff;
          }
        }
      }
    }
  }
}
</style>
